import type { JSX } from '@builder.io/qwik';
import { Slot, component$ } from '@builder.io/qwik';
import { cva } from 'class-variance-authority';

const cssClasses = cva('flex flex-wrap justify-center', {
  variants: {
    background: {
      black: 'bg-black',
      default: 'lg:justify-normal',
    },
  },
});

type ArticleBodyProps = {
  background?: 'black' | 'default';
};

export default component$<ArticleBodyProps>(
  ({ background = 'default' }): JSX.Element => {
    return (
      <div class={cssClasses({ background })} id='article-body'>
        <Slot />
      </div>
    );
  }
);
